function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var Framework = function Framework(el) {
  return Framework.fn.init(el);
};
Framework.__proto__ = Framework.prototype = {};
Framework.v = {};
Framework.f = {};
Framework.f.init = function (el) {};
Framework.fn.extend = function (name, func) {
  if (typeof name == "string") {
    Framework.extend(Framework.fn, {
      name: func
    });
  } else if (_typeof(name) == "object") {
    for (var n in name) {
      Framework.fn.extend(n, name[n]);
    }
  }
  return Framework.fn;
};
Framework.extend = function (name, func) {
  if (typeof name == "string") {
    Framework[name] = func;
  } else if (_typeof(name) === _typeof(func) === "object") {
    $keys = Object.keys(func);
    for (var i = 0; i < $keys.length; i++) {
      var n = $keys[i];
      var v = func[n];
      name[n] = v;
    }
  }
  return Framework;
};
Framework.extend(Framework.fn, {
  ready: function ready(callback) {
    var _this = this;
    this[0].addEventListener('readystatechange', function (e) {
      if (_this[0].readyState === "complete") {
        callback();
        return true;
      }
    });
  },
  each: function each(callback) {
    if (callback && typeof callback == 'function') {
      for (var i = 0; i < this.length; i++) {
        callback(this[i], i);
      }
      return this;
    }
  },
  siblings: function siblings() {
    var _this2 = this;
    return _toConsumableArray(this[0].parentNode.children).filter(function (c) {
      return c != _this2[0];
    });
  },
  addClass: function addClass(className) {
    this.each(function (el) {
      el.classList.add(className);
    });
    return this;
  },
  removeClass: function removeClass(className) {
    this.each(function (el) {
      el.classList.remove(className);
    });
    return this;
  },
  hasClass: function hasClass(className) {
    return this[0].classList.contains(className);
  },
  css: function css(propertyObject) {
    this.each(function (el) {
      Object.assign(el.style, propertyObject);
    });
    return this;
  },
  attr: function attr(_attr) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var getattr = this;
    if (value) {
      this.each(function (el) {
        el.setAttribute(_attr, value);
      });
    } else {
      getattr = this[0].getAttribute(_attr);
    }
    return getattr;
  },
  html: function html(data) {
    if (data) {
      this.each(function (el) {
        el.innerHTML = data;
      });
    } else {
      return this[0].innerHTML;
    }
    return this;
  },
  prepend: function prepend(el) {
    this[0].prepend(el);
    return this;
  },
  append: function append(el) {
    this[0].append(el);
    return this;
  },
  hide: function hide() {
    this.each(function (el) {
      el.style.display = "none";
    });
    return this;
  },
  show: function show() {
    this.each(function (el) {
      el.style.display = "block";
    });
    return this;
  },
  on: function on(event, child) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (callback != null) {
      var selector = child;
      this.each(function (element) {
        element.addEventListener(event, function (event) {
          if (event.target.matches(selector + ', ' + selector + ' *')) {
            callback.apply(event.target.closest(selector), arguments);
          }
        });
      });
    } else {
      //if the callback argument is not present then assume  the child argument is being use as callback
      callback = child;
      this.each(function (element) {
        element.addEventListener(event, callback);
      });
    }
    return this;
  }
});
export { Framework };